<template>
  <thead>
    <tr>
      <th v-if="headInfo.fstColumn" class="funcHead" :style="headInfo.style"></th>
      <th v-for="(text,index) in headInfo.dataList" :key="index">{{$t(`table.head.${text}`)}}</th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'TableHead',
  props: ['headInfo'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>
button{
  height:40px;
  border:1px solid black;
}
th {
  height: 35px;
  background: #0c4695;
  color: #fff;
  font-weight: 500;
  vertical-align: middle;
  font-size:1em;
}
.funcHead{
  width:0;
}
</style>
